<template>
    <div>
        <card class='stripe-card'
          :class='{ complete }'
          :stripe="pk"
          :options='stripeOptions'
          @change='change($event)'
        />
        <div id="card-errors" role="alert" v-text="errorMessage"></div>
    </div>
</template>

<script>
    import { Card, createToken } from 'vue-stripe-elements-plus'

    export default {
        components: { Card },
        props: [
            'pk',
        ],
        data () {
            return {
              complete: false,
              errorMessage: '',
              stripeOptions: {
                // see https://stripe.com/docs/stripe.js#element-options for details
                style: {
                  base: {
                    color: '#32325d',
                    
                    fontFamily: '"Nunito", sans-serif',
                    fontSize: '14.4px',
                    '::placeholder': {
                      color: '#aab7c4'
                    }
                  },
                  invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                  }
                },
                hidePostalCode: false
            }
          }
        },
        methods: {
            pay () {
              // createToken returns a Promise which resolves in a result object with
              // either a token or an error key.
              // See https://stripe.com/docs/api#tokens for the token object.
              // See https://stripe.com/docs/api#errors for the error object.
              // More general https://stripe.com/docs/stripe.js#stripe-create-token.
              createToken().then(data => console.log(data.token))
            },

            change(event) {
                // if (event.error) {
                //   this.errorMessage = event.error.message;
                // } else {
                //   this.errorMessage = ''
                // }

                this.errorMessage = event.error ? event.error.message : ''
            }
      }
    }
</script>
<style>
      .spacer {
          margin-bottom: 24px;
      }
      /**
       * The CSS shown here will not be introduced in the Quickstart guide, but shows
       * how you can use CSS to style your Element's container.
       */
      .StripeElement {
        background-color: white;
        padding: 12px 12px 10px;
        border-radius: 4px;
        border: 1px solid #ccd0d2;
        box-shadow: none;
        -webkit-transition: box-shadow 150ms ease;
        transition: none;
      }
      .StripeElement--focus {
        box-shadow: none;
      }
      .StripeElement--invalid {
        border-color: #fa755a;
      }
      .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
      }
      #card-errors {
          color: #fa755a;
      }
  </style>